// Shared style constants for the New Order page.

export const fmt = (v) => new Intl.NumberFormat('pt-PT', {
  style: 'currency', currency: 'EUR',
}).format(v || 0);

export const inputCls = "w-full px-3 py-2 border border-[#D1D5DB] rounded-md text-sm focus:ring-2 focus:ring-[#0F1829]/30 focus:border-[#0F1829] outline-none";
export const selectCls = `${inputCls} bg-white`;
export const boxCls = "border border-[#E5E7EB] rounded-lg p-4";

export const formatAddr = (a) => `${a.Nome} - ${a.Morada}, ${a.CodigoPostal} ${a.Localidade}`;
